import styled from "styled-components"

const TableWrapper = styled.div`
  --border-color: var(--pricing-medium);
  --border: 1px solid var(--border-color);
  --background-color: var(--pricing-light);

  a {
    display: inline-block;
    border: 2px solid;
    text-decoration: none;
    padding-inline: var(--size-space-sm);
    padding-block: var(--size-space-xs);
    border-radius: var(--size-radius-md);
  }

  > div {
    overflow-x: unset;
  }

  > p:last-of-type {
    padding: var(--size-space-lg);

    @media (min-width: 768px) {
      border: var(--border);
      border-top: none;
    }
  }

  table {
    border-spacing: 0;
    line-height: 1.5;
    margin: 0;
    background: var(--background-color);
    color: var(--color-grey-90);
    border-collapse: collapse;
  }

  & tbody th,
  & tbody td {
    border: none;
    padding-block: var(--size-space-lg);
    padding-inline: var(--size-space-lg);

    &:nth-child(n + 2) {
      text-align: center;
    }

    &:nth-child(n + 2) {
      text-align: center;
    }

    &:nth-child(1) {
      border-right: var(--border);
      padding-inline: var(--size-space-lg);
      padding-block: var(--size-space-sm);
      max-width: 300px;
    }

    p {
      margin-bottom: 0;
      font-size: var(--font-size-sm);
    }

    b {
      font-size: var(--font-size-md);
    }

    @media (min-width: 768px) {
      border: var(--border);
    }
  }

  & tbody th b {
    // We use asterisks in the Network services tab, which
    // breaks vertical alignment in Safari.
    vertical-align: middle;
  }

  & tbody tr:nth-child(1) {
    display: none;

    @media (min-width: 768px) {
      display: table-row;
      border-bottom: var(--border);
    }

    th {
      border-bottom: var(--border);
      box-shadow: inset 0px -1px 0px 0px var(--border-color);
      position: sticky;
      top: 11.75em;
      z-index: 9;
      background-color: var(--background-color);
    }
  }

  & tbody tr:nth-child(2) td {
    border-top: 1px solid var(--grey-30);
  }

  // highlight the second row
  & tr:nth-child(2) {
    outline: 2px solid var(--color-v3-red-40);
    outline-offset: -2.5px;
  }

  // Stripe rows
  & tbody tr:nth-child(2n) {
    background: var(--white);
  }

  // Mobile column colapse
  td {
    display: none;

    &:nth-child(1) {
      display: table-cell;
    }

    @media (min-width: 768px) {
      display: table-cell;
    }
  }

  &[data-active-column="0"] td {
    &:nth-child(2) {
      display: table-cell;
    }
  }

  &[data-active-column="1"] td {
    &:nth-child(3) {
      display: table-cell;
    }
  }

  &[data-active-column="2"] td {
    &:nth-child(4) {
      display: table-cell;
    }
  }

  &[data-active-column="3"] td {
    &:nth-child(5) {
      display: table-cell;
    }
  }

  & tbody th {
    font-weight: 500;

    &:first-letter {
      text-transform: uppercase;
    }
  }

  td > div[data-icon="check"],
  td > div[data-icon="cross"] {
    background-color: var(--color-grey-90);
    justify-self: center;
  }
`

export { TableWrapper }
